import findLastIndex from 'lodash/findLastIndex';
import findLast from 'lodash/findLast';
import messageEnums from 'enums/messages';

/*
 * fromSmoochConversationToSession
 *
 * generate a gladly chat session from a smooch conversation
 */
export default function fromSmoochConversationToSession(conversation, storedSession) {
  let messages = conversation.messages;
  let session = { id: conversation._id };
  let customerIndex = findLastIndex(messages, m => {
    return m.role === 'appUser' && m.metadata.subType === messageEnums.SUB_TYPES.TEXT;
  });
  let endIndex = findLastIndex(messages, m => {
    return m.metadata.subType === messageEnums.SUB_TYPES.SESSION_END;
  });
  let lastUrlMessage = findLast(messages, m => m.metadata.subType === messageEnums.SUB_TYPES.URL);
  let firstMessageUrl = messages[endIndex + 1] && messages[endIndex + 1].metadata.url;
  session.customerUrl = lastUrlMessage ? lastUrlMessage.metadata.url : firstMessageUrl;

  if (endIndex <= customerIndex) {
    session.isEnded = false;
  } else {
    session.isEnded = true;
    session.endedReason = messages[endIndex].text;
  }

  if (storedSession && storedSession.welcomeMessage) {
    session.welcomeMessage = storedSession.welcomeMessage;
  }

  return session;
}
